export { NearLink, type NearLinkProps } from "./near-link";
